'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getBoundary = getBoundary;

var _xhr = require('./xhr');

var _fetch = require('./fetch');

function getBoundary() {
    var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var contentTypeParts = contentType.split(';');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = contentTypeParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var contentTypePart = _step.value;

            var _trim$split = (contentTypePart || '').trim().split('='),
                _trim$split2 = _slicedToArray(_trim$split, 2),
                key = _trim$split2[0],
                value = _trim$split2[1];

            if (key === 'boundary' && !!value) {
                if (value[0] === '"' && value[value.length - 1] === '"') {
                    return value.substr(1, value.length - 2);
                }
                return value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return '-';
}